const inputStyle = {
    borderColor: 'hsl(0,0%,80%)',
    borderRadius: '4px',
    borderStyle: 'solid',
    borderWidth: '1px',
};

const customSelect = {
    control: (base) => ({
        ...base,
        height: 35,
        minHeight: 35,
    }),
};

const notification = {
    position: 'top-right',
    autoClose: 6000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    limit: 1,
};

const changeSizeValues = [
    { value: '0', label: '10' },
    { value: '1', label: '20' },
    { value: '2', label: '50' },
];

const refresh = () => {
    window.location.reload();
}

const customStylesfw = {
    menuPortal: (base) => ({ ...base, zIndex: 9999, width: '100%' }),
    container: (provided) => ({
        ...provided,
        width: '30vw',
        minWidth: '10rem',
        height: '2rem',
        display: 'flex',
        flex: '1',
    }),
    menu: (provided) => ({
        ...provided,
        width: '300%',
        maxWidth: "430px"
    }),
    control: (provided) => ({
        ...provided,
        display: 'flex',
        minHeight: '2rem',
        flex: '1',
        maxWidth: '100% !important',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        display: 'none',
    }),
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        width: '20vw',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    })
};

const customStylesfwreceived = {
    menuPortal: (base) => ({ ...base, zIndex: 9999, width: '100%' }),
    container: (provided) => ({
        ...provided,
        width: '28vw',
        minWidth: '10rem',
        display: 'flex',
        flex: '1',
    }),
    menu: (provided) => ({
        ...provided,
    }),
    control: (provided) => ({
        ...provided,
        display: 'flex',
        minHeight: '2rem',
        flex: '1',
        maxWidth: '100% !important',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        display: 'none',
    }),
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        width: '20vw',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    })
};


const customOrderStylesfw = {
    menuPortal: (base) => ({ ...base, zIndex: 9999, width: '100%' }),
    container: (provided) => ({
        ...provided,
        width: '30vw',
        minWidth: '10rem',
        height: '2rem',
        display: 'flex',
        flex: '1',
    }),
    menu: (provided) => ({
        ...provided,
        width: '120%',
    }),
    control: (provided) => ({
        ...provided,
        display: 'flex',
        minHeight: '2rem',
        maxWidth: '100% !important',
        flex: '1',
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none',
    }),
    indicatorsContainer: (provided) => ({
        ...provided,
        position: 'relative',
        top: '-3px'
    }),
    valueContainer: (provided) => ({
        ...provided,
        position: "",

    }),
    singleValue: (provided) => ({
        ...provided,
        paddingRight: '35px',
    }),
    dropdownIndicator: () => ({ display: 'none' }),
    placeholder: (provided) => ({
        ...provided,
        whiteSpace: 'nowrap',
        width: '12vw',
        overflow: 'hidden',
        textOverflow: 'ellipsis'
    })
};

const listResultValues = [
    { value: 10, label: '10' },
    { value: 20, label: '20' },
    { value: 50, label: '50' },
];

const statusOptions = [
    { value: -1, label: 'Tất cả' },
    { value: 2, label: 'Hoạt động' },
    { value: 1, label: 'Không hoạt động' },
];

const statusFormOptions = [
    { value: 2, label: 'Hoạt động' },
    { value: 1, label: 'Không hoạt động' },
];

export {
    inputStyle,
    customStylesfwreceived,
    customSelect,
    notification,
    changeSizeValues,
    refresh,
    customOrderStylesfw,
    customStylesfw,
    listResultValues,
    statusOptions,
    statusFormOptions,
};
